import React from "react";
import { Nav, Tab } from "react-bootstrap";
import BroadcastMessagingReport from "./BroadcastMessagingReport";
import InboundCampaignMessaging from "./InboundCampaignMessaging";
import BoomLogicWFMessaging from "./BoomLogicWFMessaging";
import HelpButton from "../HelpContent/HelpButton";
import Logs from "./Logs";

export default function ReportingOverview() {
  return (
    <div className="bg-white p-4 rounded-3">
      <div className="fw-bold ">
        REPORTING OVERVIEW <HelpButton helpKey="reporting-overview" />
      </div>

      <div className="mt-2">
        <Tab.Container
          id="reporting-overview-tabs"
          defaultActiveKey="boomLogicWFMessaging"
          mountOnEnter
        >
          <Nav className="bg-purple-gradient justify-content-center rounded-3">
            <Nav.Item>
              <Nav.Link
                className="text-secondary border-purple-gradient border-5 border-underline p-3"
                eventKey="boomLogicWFMessaging"
              >
                boomLogic WF messaging
                <HelpButton helpKey="reporting-overview-boomlogic" />
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="text-secondary border-purple-gradient border-5 border-underline p-3"
                eventKey="broadcastMessaging"
              >
                Broadcast messaging
                <HelpButton helpKey="reporting-overview-broadcast" />
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="text-secondary border-purple-gradient border-5 border-underline p-3"
                eventKey="inboundTriggers"
              >
                Inbound triggers
                <HelpButton helpKey="reporting-overview-inbound-triggers" />
              </Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
              <Nav.Link
                className="text-secondary border-purple-gradient border-5 border-underline p-3"
                eventKey="forth"
              >
                API messaging
              </Nav.Link>
            </Nav.Item> */}
            <Nav.Item>
              <Nav.Link
                className="text-secondary border-purple-gradient border-5 border-underline p-3"
                eventKey="recentActivity"
              >
                Recent Activity
                <HelpButton helpKey="reporting-overview-recent-activity" />
              </Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
              <Nav.Link
                className="text-secondary border-purple-gradient border-5 border-underline p-3"
                eventKey="sixth"
              >
              Assets
              </Nav.Link>
            </Nav.Item> */}
          </Nav>
          <Tab.Content className="my-4">
            <Tab.Pane eventKey="boomLogicWFMessaging">
              <BoomLogicWFMessaging />
            </Tab.Pane>
            <Tab.Pane eventKey="broadcastMessaging">
              <BroadcastMessagingReport />
            </Tab.Pane>
            <Tab.Pane eventKey="inboundTriggers">
              <InboundCampaignMessaging />
            </Tab.Pane>
            <Tab.Pane eventKey="forth">Broadcast4</Tab.Pane>
            <Tab.Pane eventKey="recentActivity">
              <Logs />
            </Tab.Pane>
            <Tab.Pane eventKey="first">Map</Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
}
